<div class="main-page cadastros">
    <div class="container-fluid">
        <app-title>{{ title ? title : 'Inserir novo' }} </app-title>

        <div class="row mt-3 no-gutters p-4 row-form">
            <div class="col-12">
                <form [formGroup]="manutencaoForm" (ngSubmit)="submitForm()">
                    <h2 class="mb-3">Nova Manutenção</h2>
                    <div class="form-row">
                        <div class="form-group col-lg-6">
                            <mat-form-field>
                                <mat-label>Placa do Veículo</mat-label>
                                <mat-select formControlName="veiculo" [(value)]="veiculoSelected" required>
                                    <mat-option *ngFor="let types of vehicle" [value]="types.id">
                                        {{ types.cdPlaca }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-lg-2">
                            <mat-form-field appearance="outline">
                                <mat-label>KM</mat-label>
                                <input formControlName="nrQuilometragem" matInput placeholder="Quilometragem"  (keypress)="numberOnly($event)"/>
                            </mat-form-field>
<!--
                            <validation-errors [form]="manutencaoForm" controlLabel="Número Quilometragem"
                                controlName="nrQuilometragem">
                            </validation-errors>
-->
                        </div>
                        <div class="form-group col-lg-2">
                            <mat-form-field appearance="outline">
                                <mat-label>Data Manutenção</mat-label>
                                <input formControlName="dtManutencao" type="date" matInput
                                    placeholder="Data Manutenção" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Descrição</mat-label>
                                <input formControlName="dsDescricao" required matInput placeholder="Descrição" maxlength="200" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="errorMessage" class="alert alert-danger">
                        {{ errorMessage }}
                    </div>

                    <div class="form-group mt-2 mb-0 text-center">
                        <back-button></back-button>
                        <button type="submit"
                            class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                            Salvar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

